
export default {
    name: "Breadcrumb",
    props:{
      data: {
        type: Object,
        default: () => ({}),
      },
      pageTitle: {
        type: String,
        default: null,
      }
    },
    data() {
      return {
        breadcrumbLayer: [],
        path: this.$route.path,
        show: false,
      }
    },


    computed: {

    },

    mounted() {
      let pageTitle = this.pageTitle;
      this.breadcrumbLayer.push({text: this.$t('breadcrumb.home'), link: "/"});
      console.debug(this.path);
      const layerArray = this.path.split("/").slice(2);
      let accumulateLayer= "";
      let skipNext = false;
      layerArray.forEach((element, index) => {
        if(skipNext)
        {
          skipNext = false;
          return;
        }
        accumulateLayer = accumulateLayer!==""?accumulateLayer+".":accumulateLayer;
        accumulateLayer += element;
        let searchKey = 'breadcrumb.'+this.toCamelCase(accumulateLayer);
        if(searchKey.includes('-2024')){
          searchKey = searchKey.replace('-2024', '');
        }

        // deferred annuity special handling
        if(element==="deferred-annuity")
        {
          skipNext = true;
          if(layerArray.length > index+1)
          {
            switch(layerArray[index+1]){
              case 'longevity':
              // case 'retirement':
              //   searchKey += "."+layerArray[index+1];
              //   accumulateLayer += "?objective="+layerArray[index+1]
              //   break;
              default:
              searchKey += '.default';
            }
          }
          else
          {
            switch(this.$route.query.objective){
              case 'longevity':
              // case 'retirement':
              //   searchKey += "."+this.$route.query.objective;
              //   break;
              default:
              searchKey += '.default';
            }
          }
        }

        // console.debug(searchKey);
        if(this.$t(searchKey) !== searchKey) // search the breadcrumb text in locale file first
        {
          if(typeof this.$t(searchKey) === 'object')
          {
            this.breadcrumbLayer.push({text: this.$t(searchKey+".title"), link: "/"+accumulateLayer.replace(".","/")});
          }
          else
          {
            this.breadcrumbLayer.push({text: this.$t(searchKey), link: "/"+accumulateLayer.replace(".","/")});
          }
        }
        else
        {
          console.debug(searchKey, " not found");

          if(isNaN(element)) // to dynamically handle pages with year category
          {
            if(pageTitle){
              this.breadcrumbLayer.push({text: pageTitle, link: "/"+accumulateLayer.replace(".","/")});
              pageTitle = null;
            }
            else
            {
              console.debug("no page title");
            }
          }
          else
          {
            // add the year text to previous layer
            console.debug(this.breadcrumbLayer[this.breadcrumbLayer.length-1].text);
            if(!this.breadcrumbLayer[this.breadcrumbLayer.length-1].link.includes('happy-kids'))
              this.breadcrumbLayer[this.breadcrumbLayer.length-1].text += ' '+element
          }
        }
      })

      if(this.breadcrumbLayer.length>2)
      {
        this.show = true;
      }
    },
    methods: {
      toCamelCase(text) {
        let returnText = text.toLowerCase().replace(/([-_][a-z])/g, group =>
          group
            .toUpperCase()
            .replace('-', '')
            .replace('_', '')
        );

        // special handling for 5star
        returnText = returnText.replace('5star', 'fiveStar').replace(/\d{1,}\./, '');

        return returnText;
      }
    },


}
